import type {
  TemplateApi,
  TemplateContentVersionDetailApi,
  TemplateContentVersionSummaryApi,
  TemplateListItemApi,
  TemplatePageInfoApi,
} from '../types/templates-api.types';
import type {
  Template,
  TemplateContentVersionDetail,
  TemplateContentVersionSummary,
  TemplateListItem,
  TemplatesPagingResult,
} from '../types/templates.types';

export const mapTemplateApi = (api: TemplateApi): Template => ({
  itemId: api.itemId,
  name: api.name,
  description: api.description ?? null,
  category: api.category ?? null,
  thumbnailUrl: api.thumbnailUrl ?? null,
  contentId: api.contentId?.trim() || null,
  currentVersion: api.currentVersion ?? null,
  html: api.html ?? null,
  plainText: api.plainText ?? null,
  links: api.links ?? [],
  createdAt: api.createdAt,
  updatedAt: api.updatedAt,
});

export const mapTemplateListItemApi = (api: TemplateListItemApi): TemplateListItem => ({
  itemId: api.itemId,
  name: api.name,
  description: api.description ?? null,
  category: api.category ?? null,
  thumbnailUrl: api.thumbnailUrl ?? null,
  hasContent: api.hasContent,
  currentVersion: api.currentVersion ?? null,
  createdAt: api.createdAt,
  updatedAt: api.updatedAt,
});

export const toTemplatesPagingResult = (
  items: TemplateListItem[],
  pageNo: number,
  pageSize: number,
  pageInfo: TemplatePageInfoApi
): TemplatesPagingResult => ({
  items,
  totalCount: pageInfo.total,
  pageNo,
  pageSize,
  totalPages: pageSize > 0 ? Math.max(1, Math.ceil(pageInfo.total / pageSize)) : 1,
  hasNextPage: pageInfo.hasNext,
  hasPreviousPage: pageInfo.hasPrev,
  totalUnfiltered: pageInfo.totalUnfiltered,
});

export const mapTemplateContentVersionSummaryApi = (
  api: TemplateContentVersionSummaryApi
): TemplateContentVersionSummary => ({ ...api });

export const mapTemplateContentVersionDetailApi = (
  api: TemplateContentVersionDetailApi
): TemplateContentVersionDetail => ({
  ...api,
  plainText: api.plainText ?? null,
  links: api.links ?? [],
});
